import * as React from 'react';
import Box from '@mui/material/Box';
import CalendarHeadingSection from './TimelineCalendarHeaderRow';
import { Order, Photographer } from '../../BookingsCalendarTypes';
import TimelineCalendarPhotographerRow from './TimelineCalendarPhotographerRow';
import { Translate } from '../../../../../shared/LanguageService';
import { ContainerSizeAndPosition } from '../../state/useCalendarContainerWidth';
import ICalendarItem from '../../../../calendar/Types';
import { getFiveMinutesSlots } from './timelineCalendarHelperFuncitons';

type TimelineLabels = {
    calendarPhotographersHeading: string;
};

type ExternalProps = {
    photographers: Photographer[];
    selectedOrder: Order;
    selectedDate: Date;
    onChangeBookingInfo: (bookingInfo: Partial<ICalendarItem>) => void;
    containerSizeAndPosition: ContainerSizeAndPosition;
    bookingInfo: Partial<ICalendarItem>;
    onChangePhotographer: (newPhotographer: Photographer) => void;
    isAdvancedMode: boolean;
    hideTravelTimes: boolean;
    activeRow: number;
    onActiveRow: (activeRow: number) => void;
};

type TimeLineCalendarProps = {
    labels: TimelineLabels;
} & ExternalProps;

const gridRowStyle = (totalNoTimeSlots) => {
    return {
        display: 'grid',
        gridTemplateColumns: `repeat(${totalNoTimeSlots}, 1fr )`,
        maxWidth: '100%',
        height: '35px',
        position: 'relative',
        alignItems: 'center'
    };
};

const TimelineCalendar = React.forwardRef(
    (props: TimeLineCalendarProps, scrollRef: React.MutableRefObject<HTMLElement>) => {
        let {
            photographers,
            selectedOrder,
            onChangeBookingInfo,
            containerSizeAndPosition,
            selectedDate,
            bookingInfo,
            onChangePhotographer,
            isAdvancedMode,
            hideTravelTimes,
            activeRow,
            onActiveRow
        } = props;

        let fiveMinuteTimeSlots = getFiveMinutesSlots(selectedDate);
        let totalNoTimeSlots = fiveMinuteTimeSlots.length;

        return (
            <>
                <Box sx={gridRowStyle(totalNoTimeSlots)}>
                    <CalendarHeadingSection selectedDate={selectedDate} />
                </Box>
                {photographers.map((photographer, index) => (
                    <TimelineCalendarPhotographerRow
                        ref={scrollRef}
                        containerSizeAndPosition={containerSizeAndPosition}
                        key={photographer.id}
                        photographer={photographer}
                        rowIndex={index}
                        selectedOrder={selectedOrder}
                        bookingInfo={bookingInfo}
                        onChangeBookingInfo={onChangeBookingInfo}
                        isAdvancedMode={isAdvancedMode}
                        selectedDate={selectedDate}
                        onChangePhotographer={onChangePhotographer}
                        hideTravelTimes={hideTravelTimes}
                        activeRow={activeRow}
                        onActiveRow={onActiveRow}
                    />
                ))}
            </>
        );
    }
);

const TimelineCalendarTranslationLayer = React.forwardRef(
    (props: ExternalProps, scrollRef: React.MutableRefObject<HTMLElement>) => {
        let labels: TimelineLabels = {
            calendarPhotographersHeading: Translate(
                'orders/list/bookings-calendar/photographers-heading'
            )
        };
        return <TimelineCalendar {...props} labels={labels} ref={scrollRef} />;
    }
);

export default TimelineCalendarTranslationLayer;
